import ReportAvailableList from "./ReportAvailableList";
import { connect } from "react-redux";

const mapStateToProps = (state, ownProps) => {
  return {
    user: state.general.user
  };
};

export default connect(mapStateToProps, {})(ReportAvailableList);